import React from "react";
import { getNewsNb, sendNewsletter } from "../../actions/contact";
import { connect } from "react-redux";
import { tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import EditorActu from "../../components/editor/EditorActu";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme";
import { CssBaseline, Grid, Typography } from "@mui/material";
import { createEditor } from "lexical";
import { $generateHtmlFromNodes } from "@lexical/html";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { TableNode, TableCellNode, TableRowNode } from "@lexical/table";
import { ListNode, ListItemNode } from "@lexical/list";
import { ImageNode } from "../../components/editor/CustomNodes/ImageNode";

class AdminNews extends React.Component {
    state = {
        menuActive: false,
        opts: [],
        form: {
            contenu: '',
            objet: ''
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        nb: 0
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        this.props.getNewsNb();
        this.setState({
            alert: tempAlWait()
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redSendNews != this.props.redSendNews) {
            console.log(this.props.redSendNews);
            this.setState({
                alert: this.props.redSendNews.alert
            })
        }

        if (prevProps.redGetNbNews != this.props.redGetNbNews) {
            this.setState({
                alert: this.props.redGetNbNews.alert,
                nb: this.props.redGetNbNews.datas
            })
            console.log(this.props.redGetNbNews)
            if (this.props.redGetNbNews.alert.type == "succ") {
                if (this.props.redGetNbNews.datas == 0) {
                    alert("Aucun utilisateur ne s'est inscrit dans la newsletter actuellement");
                }
            }
        }
    }

    handleSave(el) {
        el.preventDefault();
        if (window.confirm(`Souhaitez-vous vraiment envoyer cette newsletter à ${this.state.nb} utilisateurs ?`)) {
            this.setState({
                alert: tempAlWait()
            })
            const editor = createEditor({
                nodes: [
                    HeadingNode,
                    ListNode,
                    ListItemNode,
                    QuoteNode,
                    CodeNode,
                    CodeHighlightNode,
                    TableNode,
                    TableCellNode,
                    TableRowNode,
                    AutoLinkNode,
                    LinkNode,
                    ImageNode
                ]
            });
            const editorState = editor.parseEditorState(this.state.form.contenu);
            editor.setEditorState(editorState);
            editor.update(() => {
                const htmlString = $generateHtmlFromNodes(editor);
                this.props.sendNewsletter({
                    contenu: htmlString,
                    objet: this.state.form.objet
                })
            })
        }
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                changeAlert={(el) => this.setState({alert: el})}
                active={this.state.menuActive}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut
                ttl="Envoyer une newsletter"
                options={this.state.opts}
            />

            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Objet **/}
                    <div className="admin__inpgrp" title="Objet de la newsletter" aria-label="Objet de la newsletter">
                        <label htmlFor="news-objet" className="admin__lab">
                            Objet *
                        </label>
                        <input
                            required
                            type="text"
                            placeholder="Objet"
                            className="admin__input"
                            id="news-objet"
                            value={this.state.form.objet}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        objet: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Contenu **/}
                    <div className="admin__inpgrp" title="Contenu" aria-label="Contenu">
                        <label htmlFor="news-contenu" className="admin__lab">
                            Contenu *
                        </label>
                        <div className="admin__txtlib">
                            <ThemeProvider theme={theme}>
                                <CssBaseline />
                                <Grid container sx={{minHeight: "300px"}} flexDirection={"column"}>
                                    <Grid item xs={9}>
                                        <EditorActu
                                            handleChange={(el) => {
                                                this.setState(prevState => ({
                                                    form: {
                                                        ...prevState.form,
                                                        contenu: el,
                                                    }
                                                }))
                                            }}
                                            value={this.state.form.contenu}
                                        />
                                    </Grid>
                                </Grid>
                            </ThemeProvider>
                        </div>
                    </div>

                    {/** Bouton envoyer **/}
                    <button
                        title="Envoyer la newsletter"
                        aria-label="Envoyer la newsletter"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSave(el)}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} />
                        <span className="admin__btnsavetxt">Envoyer</span>
                    </button>
                </form>
            </div>
            {console.log(this.state)}
            <Alert alert={this.state.alert} />
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redSendNews: state.redSendNews,
        redGetNbNews: state.redGetNbNews
    }
}

const mapDispatchToProps = {
    sendNewsletter,
    getNewsNb
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminNews);

// todo : vérifier newsletter 